module.exports = __webpack_public_path__ + "static/media/20240213111327_IMG_5357.d0cd78ed.JPG";